window.addEventListener('appinstalled', () => {

    dataLayer.push({
        'event': "pwa_install",
        'parameters': {
            'user_id': getCUID()
        }
    });
});


function getCUID() {
    var match = document.cookie.match('_ga'),
        raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
        match = raw.match(/(\d+\.\d+)$/)
    }

    console.log(match);

    return (match) ? match[1] : null;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
